import { ValidationUtility } from "../../../validation-utility";
import { IValidatorType } from "../../../validator-interface";

export interface ICreateWebhookSubscriptionRequest {
	url: string;
	subscribedEvents?: string[];
	communityId: string;
}

export const VCreateWebhookSubscription: IValidatorType<ICreateWebhookSubscriptionRequest> = {
	url: { function: ValidationUtility.validateUrl, params: [], required: true },
	subscribedEvents: { function: ValidationUtility.validateArrayStringFields, params: [0, 100], required: false },
	communityId: { function: ValidationUtility.validateObjectId, params: [], required: true },
};

export interface IGetWebhookSubscriptionRequest {
	communityId: string
}

export const VGetWebhookSubscription: IValidatorType<IGetWebhookSubscriptionRequest> = {
	communityId: { function: ValidationUtility.validateObjectId, params: [], required: true },
}

export interface IGetWebhookSubscriptionResponse {
	url?: string | null;
	subscribedEvents?: string[];
	secret?: string;
	timestamp?: number;
	status?: number;
}

export interface IVerifyWebhookUrlRequest {
	url: string;
}

export const VVerifyWebhookUrl: IValidatorType<IVerifyWebhookUrlRequest> = {
	url: { function: ValidationUtility.validateUrl, params: [], required: true },
};

export interface IVerifyWebhookUrlResponse {
	verified: boolean;
	message: string;
	statusCode?: number;
	error?: string;
}

export interface IUpdateWebhookSubscriptionRequest {
	communityId: string;
	url: string;
	subscribedEvents?: string[];
}

export const VUpdateWebhookSubscription: IValidatorType<IUpdateWebhookSubscriptionRequest> = {
	communityId: { function: ValidationUtility.validateObjectId, params: [], required: true },
	url: { function: ValidationUtility.validateUrl, params: [], required: true },
	subscribedEvents: { function: ValidationUtility.validateArrayStringFields, params: [0, 100], required: false },
};

export interface IUpdateWebhookSubscriptionResponse {
	url: string;
	subscribedEvents: string[];
	secret: string;
	timestamp: number;
	status: number;
}